import _ from 'lodash';
import type { Project, State } from '../../types';

export const selectors = {
  getDashboardProjects: (state: State): Project[] => {
    if (!state.currentUser) return [];

    if (state.currentUser.role === 'client') return state.currentUser.projects;

    return state.projects.items;
  },
  getProjectsWithMonthyLimit: (state: State | Project[]): Project[] => {
    let projectsList: Project[] = [];
    if (Array.isArray(state)) {
      projectsList = state;
    } else if (state.projects && state.projects.items) {
      projectsList = state.projects.items;
    }

    return _.filter(projectsList, 'monthly_limit') as Project[];
  },
  getProjectsWithEnabledReportSending: (state: State | Project[]): Project[] => {
    let projectsList: Project[] = [];
    if (Array.isArray(state)) {
      projectsList = state;
    } else if (state.projects && state.projects.items) {
      projectsList = state.projects.items;
    }

    return _.filter(projectsList, 'weekly_report_enabled') as Project[];
  },
};
